/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Sim_AltInputs */

const es_landing_sim_alt = /** @type {(inputs: Landing_Sim_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulador de precio: con un anuncio de 100€ al día, tras la comisión de servicio (15%) y el IVA, el armador recibe 81,85€ en su cuenta.`)
};

const gl_landing_sim_alt = /** @type {(inputs: Landing_Sim_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulador de prezo: cun anuncio de 100€ ao día, tras a comisión de servizo (15%) e o IVE, o armador recibe 81,85€ na súa conta.`)
};

const en_landing_sim_alt = /** @type {(inputs: Landing_Sim_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price simulator: with a €100/day listing, after service commission (15%) and VAT, the owner receives €81.85 in their account.`)
};

/**
* | output |
* | --- |
* | "Price simulator: with a €100/day listing, after service commission (15%) and VAT, the owner receives €81.85 in their account." |
*
* @param {Landing_Sim_AltInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_sim_alt = /** @type {((inputs?: Landing_Sim_AltInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Sim_AltInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_sim_alt(inputs)
	if (locale === "en") return en_landing_sim_alt(inputs)
	return es_landing_sim_alt(inputs)
});